import React from "react";

import MyPage from "./MyPage";

import { getRoles } from "../../redux/reducers/user";
import { getAuthToken, logoutRequest } from "../../redux/reducers/auth";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

const MyPageContainer: React.FC = () => {
  const roles = useAppSelector(getRoles);
  const auth_token = useAppSelector(getAuthToken);

  const dispatch = useAppDispatch();

  const logoutHandler = () => {
    if (auth_token) {
      dispatch(logoutRequest(auth_token));
    }
  };

  return <MyPage roles={roles} logoutHandler={logoutHandler} />;
};

export default MyPageContainer;
